import React, { useContext } from 'react'
import { Table } from 'components'
import { createAssessmentsHooks } from '.'
import { dataGridModel } from 'keys'
import { CreateAssessmentsContext } from './CreateAssessmentsContext'

const Affiliations = () => {
    const { setSelectedTestTakers, selectedTestTakers, learningGroupOpen, setLearningGroupOpen, testTakers, school, schoolStructureOptions, gradeOpen, setGradeOpen, rowOpen, setRowOpen, page, setPage, pageSize, setPageSize, searchVal, setSearchVal, sorting, setSorting, setClassIndexTab } = useContext(CreateAssessmentsContext)
    const gradesColumns = createAssessmentsHooks.useGradesTableColumns()
    const testTakersColumns = createAssessmentsHooks.useTestTakersTableColumns()

    const currentGrade = school?.data?.find(item => item.id == gradeOpen) || []
    const currentLearningGroup = currentGrade.units?.find(item => item.id == learningGroupOpen) || []

    return (
        <div className='school-classes-table'>
            <Table
                tableH={"100%"}
                withTitle
                loading={school.isFetching}
                data={{ results: school.data || [] }}
                columns={gradesColumns}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                rowOpen={gradeOpen}
                setRowOpen={setGradeOpen}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
                sorting={sorting}
                setSorting={setSorting}
                hideSorting
                hidePagination
                hideToolbar
                queryKey={schoolStructureOptions.queryKey}
                visibilityModelKey={dataGridModel.school_classes}
                selectedRowIds={selectedTestTakers} // האובייקט של ה-State { id: true }
                setSelectedRowIds={setSelectedTestTakers} // פונקציית העדכון
                onRowSelection={setSelectedTestTakers}
                collapse={{
                    show: true,
                    columns: gradesColumns,
                    showToolbar: false,
                    onCollapse: () => { },
                    data: currentGrade?.units,
                    selectedRowIds: selectedTestTakers, // האובייקט של ה-State { id: true }
                    setSelectedRowIds: setSelectedTestTakers, // פונקציית העדכון
                    onRowSelection: setSelectedTestTakers,
                    showChollapseIcon: true,
                    hideVisibilityColumns: true,
                    rowOpen: learningGroupOpen,
                    setRowOpen: setLearningGroupOpen,
                    collapse: {
                        show: true,
                        columns: testTakersColumns,
                        showToolbar: false,
                        onCollapse: () => { },
                        data: currentLearningGroup?.test_takers,
                        showChollapseIcon: true,
                        hideVisibilityColumns: true,
                        selectedRowIds: selectedTestTakers, // האובייקט של ה-State { id: true }
                        setSelectedRowIds: setSelectedTestTakers, // פונקציית העדכון
                        onRowSelection: setSelectedTestTakers,
                    }
                }}
            />
        </div>
    )
}

export default Affiliations